import { render, staticRenderFns } from "./CocinareporteinterrelacionQuicktable.vue?vue&type=template&id=a20821b0&"
import script from "./CocinareporteinterrelacionQuicktable.vue?vue&type=script&lang=js&"
export * from "./CocinareporteinterrelacionQuicktable.vue?vue&type=script&lang=js&"
import style0 from "./CocinareporteinterrelacionQuicktable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports